import { api } from "@/lib/api/client";

export interface CourseLearningPlanUnit {
  id: string;
  /** Dense zero-based ordinal among published units, in calendar order. */
  position: number;
  topic: string;
  learning_objectives: string[];
  preparation_guidance: string | null;
  recap: string | null;
  follow_up: string | null;
  /** The class this plan is on, null when it is on no class yet. */
  session_id: string | null;
  /** That class's stored number and label, its name (`classTitle`); null when the plan is on no class yet. */
  session_no: number | null;
  session_label: string | null;
  /** That class's start, null when the plan is on no class yet. */
  starts_at: string | null;
}

export interface CourseLearningPlanProjection {
  projection_version: "course-plan-learning-v1";
  course_id: string;
  units: CourseLearningPlanUnit[];
}

export const courseLearningPlanApi = {
  get: (courseId: string) =>
    api.get<CourseLearningPlanProjection>(
      `/courses/${encodeURIComponent(courseId)}/learning-plan`,
    ),
};
